module.exports = __webpack_public_path__ + "img/orgdesign.e2e38f11.svg";